// Schema for a client-configurable questionnaire (health/PARQ, new-member soft
// fields, guest-signup). Stored per client as a JSON string in client_setting
// (forms.health / forms.newMember / forms.signup) and rendered by
// DynamicQuestionnaire. Field `key`s are the question keys persisted in
// health_form_answers, so they must stay stable for a given client.

export type QuestionnaireFieldType =
    | 'radio'
    | 'checkboxGroup'
    | 'text'
    | 'textarea'
    | 'date'
    | 'select'
    | 'boolean'
    // Display-only paragraph (e.g. the PARQ "if you answered YES…" notice).
    // Renders text but contributes no answer.
    | 'info';

export interface QuestionnaireOption {
    value: string;
    label: string;
}

export interface QuestionnaireField {
    key: string;
    label: string;
    type: QuestionnaireFieldType;
    required?: boolean;
    options?: QuestionnaireOption[];
    // Answer value(s) that should raise an operator flag on the member's health
    // tab (e.g. heartCondition flagWhen "yes"). string or list of strings.
    flagWhen?: string | string[];
}

export interface QuestionnaireSection {
    key: string;
    title?: string;
    description?: string;
    fields: QuestionnaireField[];
}

export interface QuestionnaireSchema {
    version: number;
    sections: QuestionnaireSection[];
}

export const EMPTY_SCHEMA: QuestionnaireSchema = { version: 1, sections: [] };

// Field types that never produce an answer (display-only).
export const NON_ANSWER_FIELD_TYPES: ReadonlySet<QuestionnaireFieldType> = new Set<QuestionnaireFieldType>(['info']);
